'use client'

import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-[100dvh] [backface-visibility:hidden] inset-0 z-50 flex items-center justify-center bg-white/50 dark:bg-black/50 backdrop-blur-sm">
      <div
        className="w-10 h-10 border-4 border-gray-300 dark:border-gray-700 border-t-emerald-600 dark:border-t-emerald-400 rounded-full animate-spin"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
